import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { map } from "rxjs/operators";
import { environment } from "src/environments/environment.prod";

@Injectable({
    providedIn: "root",
})
export class CheckoutService {
    constructor(private http: HttpClient) {}

    /// ======= Guest Login Auth ======= ///
    deliveryFees(data: any) {
        return this.http
            .post<any>(
                `${environment.api}/api/customer/orders/delivery_fees`,
                data
            )
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }
    checkPromo(data: any) {
        return this.http
            .post<any>(
                `${environment.api}/api/customer/orders/check_promo_v2`,
                data
            )
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }
    validiateCode(data: any) {
        return this.http
            .post<any>(
                `${environment.api}/api/customer/profile/verify_phone`,
                data
            )
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }
    placeOrder(data: any) {
        let cl_id = localStorage.getItem("cl_id");
        if (cl_id) {
            data.cl_id = cl_id;
        }
        return this.http
            .post<any>(`${environment.api}/api/customer/orders`, data)
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }
    validateCart(data: any) {
        return this.http
            .post<any>(
                `${environment.api}/api/customer/orders/validate_cart`,
                data
            )
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }

    addOrUpdateToCart(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/carts`,
            data
        );
    }

    getCart() {
        return this.http.get<any>(`${environment.api}/api/customer/carts`);
    }

    addOrUpdateToFavorite(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/products/add_products_favourite`,
            data
        );
    }

    getFavorites() {
        return this.http.get<any>(
            `${environment.api}/api/customer/products/favourites`
        );
    }

    editPhone(data: any) {
        return this.http
            .post<any>(
                `${environment.api}/api/customer/profile/edit_phone`,
                data
            )
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }

    /*resendVerify(data) {
    return this.http.post<any>(`${environment.api}/api/customer/orders`, data).pipe(
      map((data) => {
        return data;
      })
    );
  }*/

    resendVerify(data:any = {}) {
        return this.http.post<any>(
            `${environment.api}/api/customer/profile/resend_verification`,data
        );
    }

    getOrderById(id: number) {
        return this.http
            .get<any>(`${environment.api}/api/customer/orders/` + id)
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }
    getReferenceById(id: number) {
        return this.http
            .get<any>(`${environment.api}/api/customer/orders/${id}/sub-orders`)
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }
    getOrderGuestById(id: number) {
        return this.http
            .get<any>(`${environment.api}/api/customer/guest/orders/` + id)
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }
    getOrderPackagesById(id: number) {
        return this.http
            .get<any>(`${environment.api}/api/customer/orders/${id}/packages` )
            .pipe(
                map((data) => {
                    return data;
                })
            );
    }

    returnItems(id:number, data:any) {
        return this.http
        .post<any>(`${environment.api}/api/customer/orders/${id}/return-items`, data )
        .pipe(
            map((data) => {
                return data;
            })
        );
      }
}
